const Form076EN = {
    stepName: {
        importantNotes: "Important Notes",
        parentParticulars: "Particulars of Parent",
        childrenParticulars: "Particulars of Children in Need of Assistance",
        confirmation: "Confirmation",
    },
    title: {
        note: "Note",
        enquiries: "Enquiries",
        contactDetailsOfREOs: "Contact details of REOs under EDB",
        contactDetailsOfChildren:
            "Contact details of Placement and Support Section under EDB",
        basicEducationInformation:
            "Introduction to Education Services in the HKSAR",
        basicEducationInformationUrl:
            "https://www.edb.gov.hk/attachment/en/student-parents/placement-assistance/about-placement-assistance/Business%20Reply%202020.12_E.pdf",
        assistanceRequired: "Assistance required:",
    },
    label: {
        name: "Name",
        officeTelephone: "Office telephone number",
        contactTelephone: "Local contact telephone number",
        address: "Address",
        sameAddress: "Same as correspondence address",
        correspondenceAddress:
            "Correspondence Address (if different from above)",
        email: "Email",
        birthDate: "Date of birth",
        gender: "Gender",
        leavingGrade: "Grade at leaving of previous school",
        leavingDate: "Date of leaving from school",
        firstArrivalDate: "Date of first arrival in Hong Kong",
        joiningProgramme: "joining in the Induction Programme",
        enrollingProgramme: "enrolling in the Initiation Programme",
        enrollingMainstream: "enrolling in a local mainstream school",
        enrollingSpecial: "enrolling in a special school:",
        intellectualDisability:
            "School for Children with Intellectual Developmental Disorder",
        hearingImpairment: "School for Children with Hearing Impairment",
        visualImpairment: "School for Children with Visual Impairment",
        physicalDisability: "School for Children with Physical Disability",
        educationalAssistance: "Other educational assistance (please specify)",
        genderOptions: {
            male: "Male",
            female: "Female",
        },
    },
    errorMsg: {
        officeTelephone: "office telephone number",
        parentName: "parent's name",
        contactTelephone: "local contact telephone number",
        address: "address",
        correspondenceAddress:
            "correspondence address (if different from above)",
        specify: "Plesae specify other educational assistance required",
        validSpecify: "Specify",
        childName: "child's name",
        birthDate: "date of birth",
        gender: "gender",
        requiredAgreement:
            "Please check the box if you understand and agree to the above terms and conditions.",
        leavingGrade: "the grade when leaving the previous school",
        leavingDate: "date of leaving from school",
        firstArrivalDate: "date of first arrival in Hong Kong",
        email: "email",
    },
    note: {
        note1: "To enquire about the aforesaid education services, new arrivals may call EDB's 24-hour hotline or visit EDB website <a href='https://www.edb.gov.hk'>https://www.edb.gov.hk</a>.",
        note2: "EDB's 24-hour hotline: 2891 0088",
        note3: "",
        note4: "New arrivals may also bring along their children and the originals and photocopies of the documents required to the REOs for registration for placement assistance services.",
        note5: "REO",
        note6: "Address",
        note7: "Telephone Number",
        note8: "Fax Number",
        note9: "Hong Kong Regional Education Office",
        note10: "3/F, 14 Taikoo Wan Road<br/>Taikoo Shing<br/>Hong Kong",
        note11: "2863 4646",
        note12: "2865 0658",
        note13: "Kowloon Regional Education Office",
        note14: "Podium, East Block<br/>Education Bureau<br/>Kowloon Tong Education Services<br/>Centre<br/>19 Suffolk Road<br/>Kowloon Tong, Kowloon",
        note15: "3698 4108",
        note16: "2770 2012",
        note17: "New Territories West Regional Education Office",
        note18: "19/F, Chinachem Tsuen Wan Plaza<br/>457 Castle Peak Road<br/>Tsuen Wan, New Territories",
        note19: "2437 7272",
        note20: "2416 2750",
        note21: "New Territories East Regional Education Office",
        note22: "22/F, Landmark North<br/>39 Lung Sum Avenue<br/>Sheung Shui, New Territories",
        note23: "2639 4876",
        note24: "2672 0357",
        note25: "Address",
        note26: "Telephone Number",
        note27: "Fax Number",
        note28: "Room 1424, 14/F, Wu Chung House, 213 Queen's Road East, Wanchai, Hong Kong",
        note29: "2892 6190",
        note30: "3106 2304",
        note31: "Newly Arrived Children Support Unit",
        note32: "2892 6191",
    },
    guidanceNotes: {
        title: "Personal Information Collection Statement",
        // note1: `Applicants should provide their personal particulars as required. The EDB may not be able to render assistance if the information provided is insufficient.`,
        // note2: `Personal data collected by means of this form serves as reference for schools or EDB officers in arranging school placement. When the children concerned have been offered school places or appropriate assistance, the data collected will all be disposed of if retention of such becomes unnecessary.`,
        // note3: `As stipulated in Sections 18 and 22 and Principle 6 of Schedule 1 of the Personal Data (Privacy) Ordinance, applicants are entitled to correct or access their personal data. Enquiries concerning the personal data collected in this form, including requests for access and correction to the data, should be addressed to Education Officer (Placement and Support), Placement and Support Section, EDB, at Room 1424, 14/F, Wu Chung House, 213 Queen's Road East, Wan Chai, Hong Kong (Telephone number: 2892 6191).`,
        p_title: "Purpose of Collection",
        p1_1: "The personal data provided by you in this form will be used by the EDB for one or more of the following purposes:",
        p1_a: "Activities relating to the processing, authentication and assessment on eligibility and counter-checking of the application for placement assistance;",
        p1_b: "Activities relating to matching of the personal data with the database of other relevant Government bureaux / departments in connection with the processing, authentication, assessment on eligibility and counter-checking of the application mentioned in (a) above;",
        p1_c: "Activities relating to matching of the personal data within the database of EDB for purposes of verifying / updating records of the EDB; and",
        p1_d: "Activities relating to compilation of statistics, research and Government publications.",

        p2: "The provision of personal data required by this form and during the processing of this form is obligatory.  In the event that you do not provide those personal data, we may not be able to handle or further process the application.",

        p_title3: "Classes of Transferees",
        p3_1: "The personal data you provide will be made available to persons working in EDB.  Apart from this, they may be transferred or disclosed to the parties or in the circumstances listed below:-",
        p3_a: "other Government bureaux and departments for the purposes mentioned in paragraph 1 above;",
        p3_b: "the school to which the form relates for the purposes mentioned in paragraph 1 above;",
        p3_c: "where you have given your prescribed consent to such disclosure; and",
        p3_d: "where such disclosure is authorised or required under the law or court order applicable to Hong Kong.",

        p_title4: "Access to Personal Data",
        p4: "You have the right to request access to and correction of your personal data held by EDB.  Request for access to or correction of personal data should be made in writing to Assistant Education Officer (Placement and Support)22 at Room 1424, 14/F, Wu Chung House, 213 Queen's Road East, Wanchai, Hong Kong or email to aeops22@edb.gov.hk.",
    },
};
export default Form076EN;
